import { Grid } from '@material-ui/core';
import { PickupStatus, PickupDetails, BillingDetails, PickupToggleInfo } from '../components';
import PickupInfoGridTab from './PickupInfoGrids/PickupInfoGridTab';
import { getFormattedPickupToggleInfo } from '../utils';

const RightInfoPanel = ({pickInfoStateData}) => {
  const { pickupInfo, terminalCode } = pickInfoStateData;
  const pickupToggleInfoList = getFormattedPickupToggleInfo(pickupInfo);
  return (
    <Grid container spacing={24}>
      {pickupToggleInfoList.length ? (
        <Grid item xs={12}>
          <PickupToggleInfo pickupInfoList={pickupToggleInfoList} />
        </Grid>
      ) : null}
      <Grid item xs={12}>
        <PickupStatus data={pickupInfo} />
      </Grid>
      <Grid item xs={12}>
        <PickupDetails pickupInfo={pickupInfo} terminalCode={terminalCode} />
      </Grid>
      <Grid item xs={12}>
        <PickupInfoGridTab pickInfoStateData={pickInfoStateData} />
      </Grid>
      <Grid item xs={12}>
        <BillingDetails data={pickupInfo} />
      </Grid>
    </Grid>
  );
};

export default RightInfoPanel;
